import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const ChevronDown = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <path
        d='m18 9.708-6 6-6-6'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M12 16.458a.75.75 0 0 0 .53-.22l6-6 .052-.056a.75.75 0 0 0-1.056-1.056l-.056.052-5.47 5.47-5.47-5.47a.75.75 0 1 0-1.06 1.06l6 6 .114.094a.75.75 0 0 0 .416.126'
        fill='currentColor'
      />
    )}
  </IconBase>
);
